import { render } from "./SlidePrimaryBorrower.vue?vue&type=template&id=7fd94acc&scoped=true"
import script from "./SlidePrimaryBorrower.vue?vue&type=script&lang=js"
export * from "./SlidePrimaryBorrower.vue?vue&type=script&lang=js"

import "./SlidePrimaryBorrower.vue?vue&type=style&index=0&id=7fd94acc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd94acc"]])

export default __exports__